export function scrollToElementHorizontally(container, targetElement) {

    if (container && targetElement) {
        const scrollPosition = targetElement.offsetLeft - container.offsetLeft;

        container.scrollTo({
            left: scrollPosition,
            behavior: 'smooth'
        });
    }
}

export function moveCursorToEnd(element) {
    element.focus(); // Ensure the element is focused
    const textLength = element.value.length;
    element.setSelectionRange(textLength, textLength);
}